import React, { FC, useState, useEffect } from 'react';
import './NoResultPane.scss';
import { INoResultPaneProps } from './INoResultPaneProps';
import { checkGlobalSearchHasResults } from '../../../utils/searchHelpers';
import { getFilterParametersFromUrl } from '../../../utils/urlParamHelper';
import { Heading } from '@udir-design/react/beta';

const NoResultPane: FC<INoResultPaneProps> = (props) => {
    const [altInnholdHasResults, setAltInnholdHasResults] = useState<boolean>(false);
    
    useEffect(() => {
        // Check if global search ("Alt innhold") has results
        if (props.searchQuery) {
            checkGlobalSearchHasResults(props.searchQuery).then(hasResults => {
                setAltInnholdHasResults(hasResults);
            });
        }
    }, [props.searchQuery]);
    
    return (
        <div className="NoResultPane" role="status" data-size="md">
            {/* <h2>Søket ditt ga 0 treff for <query> og {generateFilterText(props.filters)}</h2> */}
            <div className='noresultText'>
                {
                    (() => {
                        const urlFilters = props.refinementFilters ? getFilterParametersFromUrl(props.refinementFilters) : [];
                        const hasSelectedFilters = (props.filters && props.filters.length > 0) || (urlFilters && urlFilters.length > 0);
                        const gyldighet = new URLSearchParams(window.location.search).get('gyldighet');
                        const hasGyldigInnhold = gyldighet && gyldighet.includes('Gyldig innhold');
                        if (props.predefinedFilterLabel && hasGyldigInnhold) {
                            return `Søket ga 0 treff for "${props.searchQuery}" innen ${props.predefinedFilterLabel}.`;
                        }
                        const suffix = hasSelectedFilters ? ` ${(props.filters && props.filters.length === 1) || (urlFilters && urlFilters.length === 1) ? 'med valgt filter.' : 'med valgte filter.'}` : '';
                        return `Søket ga 0 treff for "${props.searchQuery}"${suffix}`;
                    })()
                }
            </div>
            <Heading className='noresultSuggestionsHeading' level={3} data-size='2xs'>Forslag:</Heading>
            <ul className='noresultSuggestionsList' data-size='md'>
                <li>Sjekk at alle ord er stavet riktig</li>
                <li>Prøv andre søkeord</li>
                <li>Prøv med mer generelle søkeord</li>

                {(() => {
                    const urlFilters = props.refinementFilters ? getFilterParametersFromUrl(props.refinementFilters) : [];
                    const hasSelectedFilters = (props.filters && props.filters.length > 0) || (urlFilters && urlFilters.length > 0);
                    if (!hasSelectedFilters) return null;
                    // When predefined filter is set, only show this tip if user has selected additional filters beyond the predefined one
                    if (props.predefinedFilterLabel) {
                        const totalFilterEntries = urlFilters.reduce((sum, f) => sum + (f.Entries ? f.Entries.length : 0), 0);
                        if (totalFilterEntries <= 1) return null;
                    }
                    return <li>Fjern noen av de valgte filtrene</li>;
                })()}

                {(() => {
                    if (!props.predefinedFilterLabel) return null;
                    const gyldighet = new URLSearchParams(window.location.search).get('gyldighet');
                    if (!gyldighet || !gyldighet.includes('Gyldig innhold')) return null;
                    return (
                        <li>Fjern filteret for "Gyldig innhold"</li>
                    );
                })()}

                {altInnholdHasResults && (
                        <li>
                            <a className="resultLink underline" href={`/?query=${props.searchQuery}`}>
                                Søk på "{props.searchQuery}" innen "Alt innhold"
                            </a>
                        </li>
                    )
                }
                {/* 
                {props.filters.length > 0 && (
                        <li>Søk på <a className="resultLink underline" href={`?k=${props.searchQuery}`}>{props.searchQuery}</a> uten filtervalg</li>
                    )
                }
                */}
            </ul>
        </div>
    );
}

const renderSearchLink = (props) => {
    //<span className="noResultsQueryLink">
    //  <button onClick={() => {props.onSearchClearFilters(props.searchQuery)}}>{props.searchQuery}</button>
    //</span>
    return (
        <span className="highlighted">
            {props.searchQuery}
        </span>
    );
}

const generateFilterText = (filters: string[]) => {
    if(filters.length === 0) {
        return "";
    } else if(filters.length === 1) {
        return <span> og filtervalget {renderHighlightedSpan(filters[0], 1)}</span>
    } else {
        let lastItem = filters.pop();
        return <span className="lowercase"> og filtervalgene {joinChildren(filters, renderHighlightedSpan, renderSeperator)} og <span className="highlighted">{lastItem}</span></span>
    }
}
const renderSeperator = (key) => {
    return ', '
}
const renderHighlightedSpan = (text, index) => {
    return <span key={`filterError-${index}`} className="highlighted">{text}</span>;
}

function joinChildren(children, render, renderSeparator) {
    return children.reduce((result, child, index) => {
      if (index < children.length - 1) {
        return result.concat([render(child, index), renderSeparator(index + '-separator')])
      }

      return result.concat(render(child, index))
    }, [])
}

export default NoResultPane;
